import React from "react";
import IconStore from "../../Chatbot/components/IconStore";
import "./index.css";
class IconStoreModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image_url: "",
    };
  }
  onSelectImage = (url) => {
    this.setState({ image_url: url });
  };
  //   addTier2 = () => {
  //     const { addService } = this.props;
  //     const { image_url, tier2_title, islink, url } = this.state;
  //     this.setState({ store_visible: false });
  //     console.log("image_url,tier2_title", image_url, tier2_title);
  //     let site_url = "";
  //     if (islink) site_url = url;
  //     addService(image_url, tier2_title, site_url);
  //   };
  onDone = () => {
    const { selectImage } = this.props;
    const { image_url } = this.state;
    selectImage(image_url);
  };
  render() {
    const { image_url } = this.state;
    const { disableBackdrop } = this.props;
    return (
      <div
        className="modal fade"
        id="choose_icon"
        tabIndex="0"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
        data-backdrop={disableBackdrop ? "false" : "true"}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Choose one icon from icon store</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <IconStore onSelectImage={this.onSelectImage} />
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
                onClick={() => {
                  if (image_url) this.onDone();
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default IconStoreModal;



// WEBPACK FOOTER //
// ./src/screens/Polls/components/IconStoreModal.js